module.exports = __webpack_public_path__ + "static/media/40.35e48788.png";